import { CommonEnums } from '../../common.enums';
import { LAttribute } from './lattribute';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { Db_PropertyType } from '../datapoint/dbPropertyType';
import { TStg_Inst } from './tstg_inst';
import { LAttributesUtil } from 'src/app/shared/grids/lattributes/lattributes.util';
import { Obj_Db_PropertiesUtil } from 'src/app/shared/utils/obj_db_properties.util';
import { Db_PropertyTypesUtil } from 'src/app/shared/utils/db_propertytypes.util';
import { AttributesUtil } from 'src/app/shared/grids/attributes/attributes.util';
import { Attribute } from './attribute';

export class TStage {
    tStg_Inst: TStg_Inst;

    lAttributes: Array<LAttribute>;
    attributes: Array<Attribute>;

    nativeDbTyp_Id: number;
    ref_Id: number;
    ref_Cd: string;
    fldr_Id: number;
    is_In_SubFlow: string;

    sel_Run_PropertyType_Cd: string;
    run_Properties: Array<Obj_Db_Property>;
    runPropertyTypes: Array<Db_PropertyType>;

    change_Ind: string;
    gen_Tab_Change_Ind: string;
    attr_Tab_Change_Ind: string;
    rProp_Tab_Change_Ind: string;

    error_Cd: string;
    error_Msg: string;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.tStg_Inst = new TStg_Inst();

        this.lAttributes = new Array<LAttribute>();
        this.attributes = new Array<Attribute>();

        this.nativeDbTyp_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
        this.is_In_SubFlow = CommonEnums.defaults.STRING_EMPTY;

        this.sel_Run_PropertyType_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.run_Properties = new Array<Obj_Db_Property>();
        this.runPropertyTypes = new Array<Db_PropertyType>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.gen_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.attr_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.rProp_Tab_Change_Ind = CommonEnums.change_Ind.NO_CHANGE;

        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(tStageTmp: TStage): TStage {
        let tStage: TStage = new TStage();
        tStage.copyFrom(tStageTmp);
        return tStage;
    }

    copy(): TStage {
        let tStageTmp: TStage = new TStage();

        tStageTmp.tStg_Inst = this.tStg_Inst.copy();

        tStageTmp.lAttributes = LAttributesUtil.getInstance().copy(this.lAttributes);
        tStageTmp.attributes = AttributesUtil.getInstance().copy(this.attributes);

        tStageTmp.nativeDbTyp_Id = this.nativeDbTyp_Id;
        tStageTmp.ref_Id = this.ref_Id;
        tStageTmp.ref_Cd = this.ref_Cd;
        tStageTmp.fldr_Id = this.fldr_Id;
        tStageTmp.is_In_SubFlow = this.is_In_SubFlow;

        tStageTmp.sel_Run_PropertyType_Cd = this.sel_Run_PropertyType_Cd;
        tStageTmp.run_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.run_Properties);
        tStageTmp.runPropertyTypes = Db_PropertyTypesUtil.getInstance().copy(this.runPropertyTypes);

        tStageTmp.change_Ind = this.change_Ind;
        tStageTmp.gen_Tab_Change_Ind = this.gen_Tab_Change_Ind;
        tStageTmp.attr_Tab_Change_Ind = this.attr_Tab_Change_Ind;
        tStageTmp.rProp_Tab_Change_Ind = this.rProp_Tab_Change_Ind;

        tStageTmp.error_Cd = this.error_Cd;
        tStageTmp.error_Msg = this.error_Msg;

        return tStageTmp;
    }

    copyFrom(tStageTmp: TStage): void {
        this.tStg_Inst.copyFrom(tStageTmp.tStg_Inst);

        LAttributesUtil.getInstance().copyFrom(this.lAttributes, tStageTmp.lAttributes);
        AttributesUtil.getInstance().copyFrom(this.attributes, tStageTmp.attributes);

        this.nativeDbTyp_Id = tStageTmp.nativeDbTyp_Id;
        this.ref_Id = tStageTmp.ref_Id;
        this.ref_Cd = tStageTmp.ref_Cd;
        this.fldr_Id = tStageTmp.fldr_Id;
        this.is_In_SubFlow = tStageTmp.is_In_SubFlow;

        this.sel_Run_PropertyType_Cd = tStageTmp.sel_Run_PropertyType_Cd;
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.run_Properties, tStageTmp.run_Properties);
        Db_PropertyTypesUtil.getInstance().copyFrom(this.runPropertyTypes, tStageTmp.runPropertyTypes);

        this.change_Ind = tStageTmp.change_Ind;
        this.gen_Tab_Change_Ind = tStageTmp.gen_Tab_Change_Ind;
        this.attr_Tab_Change_Ind = tStageTmp.attr_Tab_Change_Ind;
        this.rProp_Tab_Change_Ind = tStageTmp.rProp_Tab_Change_Ind;

        this.error_Cd = tStageTmp.error_Cd;
        this.error_Msg = tStageTmp.error_Msg;
    }

    compare(tStageTmp: TStage): string {
        let diffString: string = this.tStg_Inst.compare(tStageTmp.tStg_Inst);
        if (diffString != '') return diffString;

        diffString = this.toBaseCompare(tStageTmp);
        if (diffString != '') return diffString;

        diffString = LAttributesUtil.getInstance().compare(this.lAttributes, tStageTmp.lAttributes);
        if (diffString != '') return diffString;

        diffString = AttributesUtil.getInstance().compare(this.attributes, tStageTmp.attributes);
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.run_Properties, tStageTmp.run_Properties);
        if (diffString != '') return diffString;

        diffString = Db_PropertyTypesUtil.getInstance().compare(this.runPropertyTypes, tStageTmp.runPropertyTypes);
        if (diffString != '') return diffString;

        return '';
    }

    toBaseCompare(tStageTmp: TStage): string {
        let baseString: string = this.toBaseString();
        let baseTmpString: string = tStageTmp.toBaseString();

        if (baseString != baseTmpString) {
            return baseString + ', ' + baseTmpString;
        }

        return '';
    }

    toBaseString(): string {
        return ", nativeDbTyp_Id=" + this.nativeDbTyp_Id + ", fldr_Id =" + this.fldr_Id +
            ", is_In_SubFlow =" + this.is_In_SubFlow + ", sel_Run_PropertyType_Cd =" + this.sel_Run_PropertyType_Cd;
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "TStage [tStg_Inst=" + this.tStg_Inst.toString() + this.toBaseString() +
            ", lAttributes=" + LAttributesUtil.getInstance().toString(this.lAttributes) +
            ", attributes=" + AttributesUtil.getInstance().toString(this.attributes) +
            ", run_Properties =" + Obj_Db_PropertiesUtil.getInstance().toString(this.run_Properties) +
            ", runPropertyTypes =" + Db_PropertyTypesUtil.getInstance().toString(this.runPropertyTypes);

        if (isNotCompare) {
            str += ", change_Ind=" + this.change_Ind + ", error_Cd=" + this.error_Cd +
                ", error_Msg=" + this.error_Msg + ", ref_Id =" + this.ref_Id + ", ref_Cd =" + this.ref_Cd +
                ", gen_Tab_Change_Ind =" + this.gen_Tab_Change_Ind + ", attr_Tab_Change_Ind =" + this.attr_Tab_Change_Ind +
                ", rProp_Tab_Change_Ind =" + this.rProp_Tab_Change_Ind;
        }

        str += ']';
        return str;
    }
}